/* eslint-disable @typescript-eslint/no-require-imports */
require("smoothscroll-polyfill").polyfill()

import "@/helpers/turbo"
import { register } from "../helpers/stimulus"

import "@/styles/venues.scss"

import { setupSearchBar } from "@/components/search_bar"
import { setupTabs } from "@/components/tabs"

import AccordionController from "../controllers/accordion_controller"
import CarouselController from "../controllers/carousel_controller"
import ClearableInputController from "../controllers/clearable_input_controller"
import CounterController from "../controllers/counter_controller"
import DialogController from "../controllers/dialog_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import DrawerController from "../controllers/drawer_controller"
import DrawerGroupController from "../controllers/drawer_group_controller"
import LoaderController from "../controllers/loader_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import SnackBarController from "../controllers/snackbar_controller"
import TabsController from "../controllers/tabs_controller"
import TooltipController from "../controllers/tooltip_controller"
import TurboFrameMissingController from "../controllers/turbo_frame_missing_controller"
import WindowNavigationController from "../controllers/window_navigation_controller"
import WishlistController from "../controllers/wishlist_controller"

import ErrorTrackingController from "../controllers/tracking/error_tracking_controller"

import BookingCalendarController from "../controllers/venue/booking_calendar_controller"
import BookingFooterController from "../controllers/venue/booking_footer_controller"
import VenueCarouselController from "../controllers/venue/carousel_controller"
import PackageBookingController from "../controllers/venue/package_booking_controller"
import PackageDetailsModalController from "../controllers/venue/package_details_modal_controller"
import PackageController from "../controllers/venue/package_controller"
import PackagesController from "../controllers/venue/packages_controller"
import RoomCounterController from "../controllers/venue/room_counter_controller"
import ScrollspyController from "../controllers/venue/scrollspy_controller"
import SearchDateController from "../controllers/venue/search_date_controller"
import SearchGuestsController from "../controllers/venue/search_guests_controller"
import SearchModalController from "../controllers/venue/search_modal_controller"
import ReviewsController from "../controllers/venue/reviews_controller"

import { loadBackgroundImages } from "@/helpers/image_loader"
import { trackVisit } from "@/helpers/visit_tracker"

const setupStimulus = (): void => {
  register("accordion", AccordionController)
  register("about-venue-modal", ModalController)
  register("about-venue-modal-trigger", ModalTriggerController)
  register("booking-calendar", BookingCalendarController)
  register("booking-footer", BookingFooterController)
  register("booking-modal", ModalController)
  register("carousel", CarouselController)
  register("clearable-input", ClearableInputController)
  register("dialog", DialogController)
  register("disclosure-item", DisclosureItemController)
  register("drawer", DrawerController)
  register("drawer-group", DrawerGroupController)
  register("error-tracking", ErrorTrackingController)
  register("guests-counter", CounterController)
  register("hero-modal", ModalController)
  register("hero-modal-trigger", ModalTriggerController)
  register("loader", LoaderController)
  register("package-booking", PackageBookingController)
  register("package-details-modal", PackageDetailsModalController)
  register("page-loader", LoaderController)
  register("pax-counter", CounterController)
  register("room-counter", RoomCounterController)
  register("reviews", ReviewsController)
  register("scrollspy", ScrollspyController)
  register("snackbar", SnackBarController)
  register("tabs", TabsController)
  register("tooltip", TooltipController)
  register("turbo-frame-missing", TurboFrameMissingController)
  register("venue-carousel", VenueCarouselController)
  register("venue-package", PackageController)
  register("venue-packages", PackagesController)
  register("venue-search-date", SearchDateController)
  register("venue-search-guests", SearchGuestsController)
  register("venue-search-modal", SearchModalController)
  register("venue-search-modal-trigger", ModalTriggerController)
  register("window-navigation", WindowNavigationController)
  register("wishlist", WishlistController)
}

setupStimulus()
loadBackgroundImages()
setupSearchBar()
setupTabs()
void trackVisit("/venue_visit")
